import { LearningResourceType, MediaType } from "src/interfaces/Media";

export const ACCEPT_BY_MEDIA_TYPE: Record<MediaType, string> = {
  [MediaType.COVER]: "image/png,image/jpeg",
  [MediaType.VIDEO]: "video/mp4,video/mov",
  [MediaType.LEARNING_RESOURCE]: "application/x-zip-compressed,application/zip",
  [MediaType.DIDACTICAL_MATERIAL]:
    "text/plain,application/pdf,audio/mpeg,text/rtf,application/msword,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
  [MediaType.LEGAL_DOCUMENTATION]: "application/pdf",
  [MediaType.OTHER]: "image/svg+xml,image/png,image/jpeg",
  [MediaType.EXERCISE]: "",
};

export const resolveUploadAccept = (
  mediaType: MediaType | undefined,
  _learningResourceType?: LearningResourceType,
): string => {
  if (!mediaType) return "";
  return ACCEPT_BY_MEDIA_TYPE[mediaType] || "";
};
